import './CRUDInvestor.scss';
import Component from './CRUDInvestor.js';
export default Component;
